<template>
  <div class="tutorial-container-wrapper">
    <!-- Text -->
    <div class="text-container left-aligned">
      <div class="sub-title">
        As a Tinder-user you can request your full usage history (number of swipes, matches etc.) in one single file from Tinder. To get your data, you have to request it on
        <a
          class="page-link"
          href="https://account.gotinder.com/data"
          target="_blank"
          @click="clickLink()"
        >Tinder's website</a> and you'll receive it in a few days via email.
      </div>
      <br>
      <div class="sub-title">
        To find out how to get your data, you can check out
        <a
          class="page-link"
          href="https://www.help.tinder.com/hc/en-us/articles/115005626726-How-do-I-request-a-copy-of-my-personal-data-"
          target="_blank"
        >Tinder's FAQ</a> or follow this tutorial we created for you:
      </div>
    </div>
    <div class="video-responsive">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/qNrE3fxHZGQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div class="tutorial-container shadow">
      <!-- Tutorial steps -->
      <TutorialStep number="1">
        <p>
          1. Go to
          <a
            class="page-link"
            href="https://account.gotinder.com/data"
            @click="clickLink()"
          >https://account.gotinder.com/data</a>. This is where you can manage your Tinder account outside the app.
        </p>
      </TutorialStep>

      <TutorialStep number="2" imgSrc="tutorial/s2.png">
        <p>
          2.
          <b>Log into your account</b> either using Facebook, Google account or the phone number you registered with on Tinder.
        </p>
      </TutorialStep>

      <TutorialStep number="3" imgSrc="tutorial/s3.jpg">
        <p>
          3. Click on
          <b>Download my information</b>.
        </p>
      </TutorialStep>

      <TutorialStep number="4" imgSrc="tutorial/s4.jpg">
        <p>
          4.
          <b>Enter your email address in both fields.</b> Tinder will send you the data to this address.
        </p>
      </TutorialStep>

      <TutorialStep number="5" imgSrc="tutorial/s5.jpg">
        <p>
          5.
          <b>Click on the submit button.</b>
        </p>
      </TutorialStep>

      <TutorialStep number="6">
        <p>
          6.
          <b>Good job, you are done requesting your data!</b> Tinder will soon send you an email that contains a download link to your data.
        </p>
      </TutorialStep>
    </div>

    <div class="text-image-container">
      <div
        class="small-title"
      >When you receive the email from Tinder, visit this page again to generate your infographics!</div>
      <div class="big-title">See you soon!</div>
      <img src="@/assets/img/male-figure-waiting.svg">

      <div class="image-annotation-text">
        <div>A few days have passed.</div>
        <div>You've got the mail.</div>
        <div>What's next?</div>
      </div>
    </div>

    <div class="tutorial-container shadow">
      <TutorialStep number="7" imgSrc="tutorial/s7.jpg">
        <p>
          7.
          <b>Open Tinder's email</b> and
          <b>click on the download link within 24 hours</b> of receiving the email. The download link is at the bottom of the email.
        </p>
      </TutorialStep>

      <TutorialStep number="8" imgSrc="tutorial/s2.png">
        <p>
          8.
          <b>Log into your account</b> as you did the first time when you requested the data.
        </p>
      </TutorialStep>

      <TutorialStep number="9">
        <p>
          9.
          After you log in, your data (myData.zip) automatically gets downloaded.
          <b>Now you can upload the file on Tinder Insights to generate you infographics!</b> You can upload the zip file as is without unzipping.
        </p>
      </TutorialStep>
    </div>
  </div>
</template>

<script>
import TutorialStep from "./TutorialStep.vue";

export default {
  components: { TutorialStep },
  methods: {
    clickLink() {
      this.$store.state.analytics.logEvent("tinder link clicked");
    }
  }
}
</script>


<style scoped>
.tutorial-container-wrapper {
  width: 85%;
  max-width: 1000px;
  color: var(--dark-text-color);
  background-color: transparent;
  border-radius: 10px;
  margin: 20px auto;
}
.tutorial-container-wrapper > div {
  width: 100%;
  margin-bottom: 20px;
}

.tutorial-container {
  background-color: var(--light-text-color);
  border-radius: 10px;
}

.page-link:hover {
  text-decoration: underline;
}

/* img + text: see you soon part*/
.text-image-container {
  text-align: left;
}

.text-image-container .big-title {
  margin: 20px 0;
}

.text-image-container img {
  height: 150px;
  width: auto;
  margin-right: 40px;
}

.text-image-container img,
.text-image-container .image-annotation-text {
  display: inline-block;
}

.image-annotation-text div {
  font-size: var(--middle-font);
  font-style: italic;
}

.video-responsive{
    margin-top: 10px;
    margin-bottom: 30px;
}

@media (max-width: 767.98px) {
  .video-responsive{
      overflow:hidden;
      padding-bottom:56.25%;
      position:relative;
      margin-top: 10px;
      margin-bottom: 30px;
  }
  .video-responsive iframe{
      left:0;
      top:0;
      height:100%;
      width:100%;
      max-width: 700px;
      position:absolute;
  }
}





</style>